import type { FocusEvent } from 'react';

/**
 * Scroll a newly focused text field into the visible area above the mobile
 * on-screen keyboard.
 *
 * Inside the Digital Twin flow the page is a fixed, viewport-sized scroll
 * container, so iOS Safari's native "scroll the focused field into view" is
 * unreliable and a lower field (or a tall textarea) can stay hidden under the
 * keyboard. Attach this to the onFocus of a form/container — focus bubbles up
 * from the child input/textarea.
 *
 * The delay lets iOS finish opening the keyboard and resizing the visual
 * viewport (which the page height tracks via --vh) before we scroll; scrolling
 * too early measures the pre-keyboard layout and leaves the field hidden.
 */
export const scrollFieldIntoView = (e: FocusEvent<HTMLElement>) => {
  const target = e.target as HTMLElement;
  if (target.tagName !== 'INPUT' && target.tagName !== 'TEXTAREA') return;
  window.setTimeout(() => {
    target.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }, 300);
};
